class Retargeting {
  private instance?: typeof ADSPEND;

  constructor() {
    try {
      this.instance = ADSPEND;
    } catch {
      console.warn('ADSPEND is not defined');
    }
  }

  onReady = (data: any) => {
    this.instance?.onReady('retargeting', data);
  };
}

export default new Retargeting();
